var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 10.7168C19.7143 10.1784 20.0197 9.70503 20.4252 9.38657C21.3824 8.63482 22 7.4488 22 6.1144C22 3.84208 20.2091 2 18 2C15.7909 2 14 3.84208 14 6.1144C14 7.4488 14.6176 8.63482 15.5748 9.38657C15.9803 9.70503 16.2857 10.1784 16.2857 10.7168C16.2857 11.0965 16.5732 11.4044 16.9278 11.4044H19.0722C19.4268 11.4044 19.7143 11.0965 19.7143 10.7168Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1574 13.2507C16.1574 12.8368 16.4707 12.5013 16.8571 12.5013H19.1429C19.5293 12.5013 19.8426 12.8368 19.8426 13.2507C19.8426 13.6645 19.5293 14 19.1429 14H16.8571C16.4707 14 16.1574 13.6645 16.1574 13.2507Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.75C16.5858 22.75 16.25 22.4142 16.25 22C16.25 21.5858 16.5858 21.25 17 21.25H20.1893L12 13.0607L7.53033 17.5303C7.23744 17.8232 6.76256 17.8232 6.46967 17.5303L1.46967 12.5303C1.17678 12.2374 1.17678 11.7626 1.46967 11.4697C1.76256 11.1768 2.23744 11.1768 2.53033 11.4697L7 15.9393L11.4697 11.4697C11.7626 11.1768 12.2374 11.1768 12.5303 11.4697L21.25 20.1893V17C21.25 16.5858 21.5858 16.25 22 16.25C22.4142 16.25 22.75 16.5858 22.75 17V22C22.75 22.4142 22.4142 22.75 22 22.75H17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaDown);
export default __webpack_public_path__ + "static/media/idea-down.b9810a99f079bc38eb6539ab42254743.svg";
export { ForwardRef as ReactComponent };